import React from 'react';
import { observer } from "mobx-react-lite";
import { ImageUsecase } from '../../../../../shared/resources/ImageModel';
import { ImageSelectionWithUpload } from '../../../images/ImageSelectionWithUpload';
import { ElementGroup } from './BaseElements';
export const ImageSelectionActionDetail = observer(({
  imageId,
  imageIdSetter
}) => {
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ImageSelectionWithUpload, {
    selectedImageId: imageId,
    selectedImageIdSetter: imageIdSetter,
    imageUsecase: ImageUsecase.DisplayImage
  }));
});